import { Platform } from 'react-native';

export function isNativePlatform() {
  return Platform.OS === 'ios' || Platform.OS === 'android';
}

export function isWebBrowser() {
  return Platform.OS === 'web';
}
